var exports = {
  "_": "SubmitTooltip.module__buttonWrapper___MHJCZk",
};

module.exports = exports;
